const NoPhotos = () => {
  return (
    <svg viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Camera body */}
      <rect
        x="18"
        y="32"
        width="84"
        height="54"
        rx="7"
        fill="#e6f0f8"
        stroke="#14508c"
        strokeWidth="1.5"
      />

      {/* Viewfinder bump */}
      <path
        d="M44 32 L46 22 L74 22 L76 32 Z"
        fill="#dce8f4"
        stroke="#14508c"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />

      {/* Lens ring outer */}
      <circle
        cx="60"
        cy="59"
        r="17"
        fill="#f4f8fd"
        stroke="#14508c"
        strokeWidth="1.5"
      />

      {/* Lens ring inner */}
      <circle
        cx="60"
        cy="59"
        r="11"
        fill="#e6f0f8"
        stroke="#14508c"
        strokeWidth="1.2"
      />

      {/* Diagonal cross — "no photo" indicator */}
      <line
        x1="51"
        y1="50"
        x2="69"
        y2="68"
        stroke="#14508c"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.45"
      />
      <line
        x1="69"
        y1="50"
        x2="51"
        y2="68"
        stroke="#14508c"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.45"
      />

      {/* Flash / shutter button */}
      <rect
        x="82"
        y="38"
        width="10"
        height="7"
        rx="3"
        fill="#c8dcf0"
        stroke="#14508c"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default NoPhotos;
